export const MAX_PERCENT_CHANGES = 50;

export const DIFF_TAGS = {
  EQUAL: 'EQUAL',
  DELETE: 'DELETE',
  CHANGE: 'CHANGE',
  INSERT: 'INSERT',
} as const;

export const DIFF_PREFIXES = {
  [DIFF_TAGS.EQUAL]: '',
  [DIFF_TAGS.DELETE]: '-',
  [DIFF_TAGS.CHANGE]: '+',
  [DIFF_TAGS.INSERT]: '+',
} as const;

export const DEFAULT_CONTEXT_LINES = 3;

// Colors for different diff types
export const DIFF_COLORS = {
  [DIFF_TAGS.EQUAL]: 'text.secondary',
  [DIFF_TAGS.DELETE]: 'error.main',
  [DIFF_TAGS.CHANGE]: 'warning.main',
  [DIFF_TAGS.INSERT]: 'success.main',
} as const;
